import gql from 'graphql-tag';
import * as Urql from 'urql';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
};

/** An example input */
export type CustomerInput = {
  city?: InputMaybe<Scalars['String']>;
  communicationPreferences?: InputMaybe<Scalars['Int']>;
  country?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  first_name?: InputMaybe<Scalars['String']>;
  last_name?: InputMaybe<Scalars['String']>;
  mobile?: InputMaybe<Scalars['String']>;
  password?: InputMaybe<Scalars['String']>;
  street?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  zip?: InputMaybe<Scalars['String']>;
};

/** A type */
export type CustomerSearchResultType = {
  __typename?: 'CustomerSearchResultType';
  error?: Maybe<Scalars['String']>;
  results?: Maybe<Array<Maybe<CustomerType>>>;
};

/** A type */
export type CustomerType = {
  __typename?: 'CustomerType';
  customerNumber?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  postcode?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
};

/** A type */
export type LoginResultType = {
  __typename?: 'LoginResultType';
  customer?: Maybe<CustomerType>;
  error?: Maybe<Scalars['String']>;
  internal?: Maybe<Scalars['Boolean']>;
  /** Only if role is supplied */
  site?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  user?: Maybe<UserType>;
};

/** A type */
export type ManagementLoginResultType = {
  __typename?: 'ManagementLoginResultType';
  error?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  /** A mutation */
  ManagementLoginMutation?: Maybe<ManagementLoginResultType>;
  /** A mutation */
  createCustomer?: Maybe<LoginResultType>;
  /** Used to wrap a paymentmethod to support MOTO */
  createPaymentMethod?: Maybe<PaymentIntentType>;
  /** A mutation */
  initiatePayment?: Maybe<PaymentIntentType>;
  /** A mutation */
  login?: Maybe<LoginResultType>;
};


export type MutationManagementLoginMutationArgs = {
  password: Scalars['String'];
  theatre: Scalars['String'];
  username: Scalars['String'];
};


export type MutationCreateCustomerArgs = {
  customer?: InputMaybe<CustomerInput>;
};


export type MutationCreatePaymentMethodArgs = {
  customerToken?: InputMaybe<Scalars['String']>;
  paymentMethod?: InputMaybe<Scalars['String']>;
  productCode?: InputMaybe<Scalars['String']>;
  theatre?: InputMaybe<Scalars['String']>;
  token?: InputMaybe<Scalars['String']>;
};


export type MutationInitiatePaymentArgs = {
  customerToken?: InputMaybe<Scalars['String']>;
  productCode?: InputMaybe<Scalars['String']>;
  theatre?: InputMaybe<Scalars['String']>;
  token?: InputMaybe<Scalars['String']>;
};


export type MutationLoginArgs = {
  password: Scalars['String'];
  role?: InputMaybe<Scalars['String']>;
  username: Scalars['String'];
};

/** A type */
export type PageDataType = {
  __typename?: 'PageDataType';
  name?: Maybe<Scalars['String']>;
  values?: Maybe<Array<Maybe<PageFieldDataType>>>;
};

/** A type */
export type PageFieldDataType = {
  __typename?: 'PageFieldDataType';
  name?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** A type */
export type PaymentIntentType = {
  __typename?: 'PaymentIntentType';
  clientSecret?: Maybe<Scalars['String']>;
  error?: Maybe<Scalars['String']>;
  resultType?: Maybe<Scalars['String']>;
  subscriptionId?: Maybe<Scalars['String']>;
};

export type Query = {
  __typename?: 'Query';
  /** A query */
  customerSearch?: Maybe<CustomerSearchResultType>;
  /** A query */
  getMe?: Maybe<LoginResultType>;
  /** A query */
  siteData?: Maybe<SiteDataType>;
  /** A query */
  subscriptions?: Maybe<SubscriptionResultType>;
};


export type QueryCustomerSearchArgs = {
  customerNumber?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  postcode?: InputMaybe<Scalars['String']>;
  userToken?: InputMaybe<Scalars['String']>;
};


export type QueryGetMeArgs = {
  token: Scalars['String'];
};


export type QuerySiteDataArgs = {
  internal?: InputMaybe<Scalars['Boolean']>;
  site?: InputMaybe<Scalars['String']>;
};


export type QuerySubscriptionsArgs = {
  theatre?: InputMaybe<Scalars['String']>;
  token?: InputMaybe<Scalars['String']>;
};

/** A type */
export type SiteDataType = {
  __typename?: 'SiteDataType';
  headerColour?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  notPublic?: Maybe<Scalars['Boolean']>;
  pages?: Maybe<Array<Maybe<PageDataType>>>;
  primaryColour?: Maybe<Scalars['String']>;
  shortcutLogo?: Maybe<Scalars['String']>;
  siteUrl?: Maybe<Scalars['String']>;
  sites?: Maybe<Array<Maybe<SiteHeaderType>>>;
  stripePublicKey?: Maybe<Scalars['String']>;
  subdomain?: Maybe<Scalars['String']>;
};

/** A type */
export type SiteHeaderType = {
  __typename?: 'SiteHeaderType';
  label?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  phoneRole?: Maybe<Scalars['String']>;
  theatre?: Maybe<Scalars['String']>;
};

/** A type */
export type SubscriptionResultType = {
  __typename?: 'SubscriptionResultType';
  error?: Maybe<Scalars['String']>;
  subscriptions?: Maybe<Array<Maybe<SubscriptionType>>>;
};

/** A type */
export type SubscriptionType = {
  __typename?: 'SubscriptionType';
  code?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  price?: Maybe<Scalars['Int']>;
};

/** A type */
export type UserType = {
  __typename?: 'UserType';
  username?: Maybe<Scalars['String']>;
};

export type GetSiteDataQueryVariables = Exact<{
  site?: InputMaybe<Scalars['String']>;
  internal?: InputMaybe<Scalars['Boolean']>;
}>;


export type GetSiteDataQuery = { __typename?: 'Query', siteData?: { __typename?: 'SiteDataType', name?: string | null, siteUrl?: string | null, logo?: string | null, shortcutLogo?: string | null, headerColour?: string | null, primaryColour?: string | null, subdomain?: string | null, notPublic?: boolean | null, stripePublicKey?: string | null, pages?: Array<{ __typename?: 'PageDataType', name?: string | null, values?: Array<{ __typename?: 'PageFieldDataType', name?: string | null, value?: string | null } | null> | null } | null> | null, sites?: Array<{ __typename?: 'SiteHeaderType', theatre?: string | null, label?: string | null, phoneRole?: string | null } | null> | null } | null };

export type CreateCustomerMutationVariables = Exact<{
  customer?: InputMaybe<CustomerInput>;
}>;


export type CreateCustomerMutation = { __typename?: 'Mutation', createCustomer?: { __typename?: 'LoginResultType', token?: string | null, error?: string | null, customer?: { __typename?: 'CustomerType', token?: string | null, email?: string | null, postcode?: string | null } | null } | null };

export type CreatePaymentMethodMutationVariables = Exact<{
  productCode?: InputMaybe<Scalars['String']>;
  token?: InputMaybe<Scalars['String']>;
  theatre?: InputMaybe<Scalars['String']>;
  customerToken?: InputMaybe<Scalars['String']>;
  paymentMethod?: InputMaybe<Scalars['String']>;
}>;


export type CreatePaymentMethodMutation = { __typename?: 'Mutation', createPaymentMethod?: { __typename?: 'PaymentIntentType', clientSecret?: string | null, subscriptionId?: string | null, resultType?: string | null, error?: string | null } | null };

export type GetMeQueryVariables = Exact<{
  token: Scalars['String'];
}>;


export type GetMeQuery = { __typename?: 'Query', getMe?: { __typename?: 'LoginResultType', internal?: boolean | null, token?: string | null, site?: string | null, user?: { __typename?: 'UserType', username?: string | null } | null } | null };

export type InitiatePaymentMutationVariables = Exact<{
  productCode?: InputMaybe<Scalars['String']>;
  token?: InputMaybe<Scalars['String']>;
  theatre?: InputMaybe<Scalars['String']>;
  customerToken?: InputMaybe<Scalars['String']>;
}>;


export type InitiatePaymentMutation = { __typename?: 'Mutation', initiatePayment?: { __typename?: 'PaymentIntentType', clientSecret?: string | null, subscriptionId?: string | null, resultType?: string | null, error?: string | null } | null };

export type ListSubscriptionsQueryVariables = Exact<{
  token?: InputMaybe<Scalars['String']>;
  theatre?: InputMaybe<Scalars['String']>;
}>;


export type ListSubscriptionsQuery = { __typename?: 'Query', subscriptions?: { __typename?: 'SubscriptionResultType', error?: string | null, subscriptions?: Array<{ __typename?: 'SubscriptionType', description?: string | null, id?: string | null, name?: string | null, price?: number | null, code?: string | null } | null> | null } | null };

export type LoginMutationVariables = Exact<{
  username: Scalars['String'];
  password: Scalars['String'];
  role?: InputMaybe<Scalars['String']>;
}>;


export type LoginMutation = { __typename?: 'Mutation', login?: { __typename?: 'LoginResultType', token?: string | null, error?: string | null, internal?: boolean | null, user?: { __typename?: 'UserType', username?: string | null } | null, customer?: { __typename?: 'CustomerType', email?: string | null, postcode?: string | null, token?: string | null } | null } | null };

export type ManagementLoginMutationVariables = Exact<{
  username: Scalars['String'];
  password: Scalars['String'];
  theatre: Scalars['String'];
}>;


export type ManagementLoginMutation = { __typename?: 'Mutation', ManagementLoginMutation?: { __typename?: 'ManagementLoginResultType', error?: string | null, url?: string | null } | null };

export type CustomerSearchQueryVariables = Exact<{
  userToken?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  customerNumber?: InputMaybe<Scalars['String']>;
  postcode?: InputMaybe<Scalars['String']>;
}>;


export type CustomerSearchQuery = { __typename?: 'Query', customerSearch?: { __typename?: 'CustomerSearchResultType', error?: string | null, results?: Array<{ __typename?: 'CustomerType', email?: string | null, postcode?: string | null, token?: string | null, customerNumber?: string | null, firstName?: string | null, lastName?: string | null } | null> | null } | null };


export const GetSiteDataDocument = gql`
    query getSiteData($site: String, $internal: Boolean) {
  siteData(site: $site, internal: $internal) {
    name
    siteUrl
    logo
    shortcutLogo
    headerColour
    primaryColour
    subdomain
    notPublic
    pages {
      name
      values {
        name
        value
      }
    }
    sites {
      theatre
      label
      phoneRole
    }
    stripePublicKey
  }
}
    `;

export function useGetSiteDataQuery(options?: Omit<Urql.UseQueryArgs<GetSiteDataQueryVariables>, 'query'>) {
  return Urql.useQuery<GetSiteDataQuery, GetSiteDataQueryVariables>({ query: GetSiteDataDocument, ...options });
};
export const CreateCustomerDocument = gql`
    mutation createCustomer($customer: CustomerInput) {
  createCustomer(customer: $customer) {
    token
    customer {
      token
      email
      postcode
    }
    error
  }
}
    `;

export function useCreateCustomerMutation() {
  return Urql.useMutation<CreateCustomerMutation, CreateCustomerMutationVariables>(CreateCustomerDocument);
};
export const CreatePaymentMethodDocument = gql`
    mutation CreatePaymentMethod($productCode: String, $token: String, $theatre: String, $customerToken: String, $paymentMethod: String) {
  createPaymentMethod(
    productCode: $productCode
    token: $token
    theatre: $theatre
    customerToken: $customerToken
    paymentMethod: $paymentMethod
  ) {
    clientSecret
    subscriptionId
    resultType
    error
  }
}
    `;

export function useCreatePaymentMethodMutation() {
  return Urql.useMutation<CreatePaymentMethodMutation, CreatePaymentMethodMutationVariables>(CreatePaymentMethodDocument);
};
export const GetMeDocument = gql`
    query GetMe($token: String!) {
  getMe(token: $token) {
    user {
      username
    }
    internal
    token
    site
  }
}
    `;

export function useGetMeQuery(options: Omit<Urql.UseQueryArgs<GetMeQueryVariables>, 'query'>) {
  return Urql.useQuery<GetMeQuery, GetMeQueryVariables>({ query: GetMeDocument, ...options });
};
export const InitiatePaymentDocument = gql`
    mutation InitiatePayment($productCode: String, $token: String, $theatre: String, $customerToken: String) {
  initiatePayment(
    productCode: $productCode
    token: $token
    theatre: $theatre
    customerToken: $customerToken
  ) {
    clientSecret
    subscriptionId
    resultType
    error
  }
}
    `;

export function useInitiatePaymentMutation() {
  return Urql.useMutation<InitiatePaymentMutation, InitiatePaymentMutationVariables>(InitiatePaymentDocument);
};
export const ListSubscriptionsDocument = gql`
    query ListSubscriptions($token: String, $theatre: String) {
  subscriptions(token: $token, theatre: $theatre) {
    error
    subscriptions {
      description
      id
      name
      price
      code
    }
  }
}
    `;

export function useListSubscriptionsQuery(options?: Omit<Urql.UseQueryArgs<ListSubscriptionsQueryVariables>, 'query'>) {
  return Urql.useQuery<ListSubscriptionsQuery, ListSubscriptionsQueryVariables>({ query: ListSubscriptionsDocument, ...options });
};
export const LoginDocument = gql`
    mutation login($username: String!, $password: String!, $role: String) {
  login(username: $username, password: $password, role: $role) {
    token
    user {
      username
    }
    error
    internal
    customer {
      email
      postcode
      token
    }
  }
}
    `;

export function useLoginMutation() {
  return Urql.useMutation<LoginMutation, LoginMutationVariables>(LoginDocument);
};
export const ManagementLoginDocument = gql`
    mutation ManagementLogin($username: String!, $password: String!, $theatre: String!) {
  ManagementLoginMutation(
    username: $username
    password: $password
    theatre: $theatre
  ) {
    error
    url
  }
}
    `;

export function useManagementLoginMutation() {
  return Urql.useMutation<ManagementLoginMutation, ManagementLoginMutationVariables>(ManagementLoginDocument);
};
export const CustomerSearchDocument = gql`
    query CustomerSearch($userToken: String, $email: String, $customerNumber: String, $postcode: String) {
  customerSearch(
    email: $email
    customerNumber: $customerNumber
    userToken: $userToken
    postcode: $postcode
  ) {
    results {
      email
      postcode
      token
      customerNumber
      firstName
      lastName
    }
    error
  }
}
    `;

export function useCustomerSearchQuery(options?: Omit<Urql.UseQueryArgs<CustomerSearchQueryVariables>, 'query'>) {
  return Urql.useQuery<CustomerSearchQuery, CustomerSearchQueryVariables>({ query: CustomerSearchDocument, ...options });
};